module.exports = __webpack_public_path__ + "img/mind_background_6.a897c391.png";